import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import './Pathfinder.styles.scss';
import { getPrevNextItems } from './Pathfinder.logic';

const Pathfinder: React.FC = () => {
  const location = useLocation();
  const { prevItem, nextItem } = getPrevNextItems(location.pathname);

  return (
    <div className="pathfinder">
      <div className="pathfinder-wrapper">
        <div className="block">
          <div className="pathfinder-prev">
            {prevItem && (
              <div>
                <Link to={prevItem.path}>&larr; {prevItem.label}</Link>
                <p className="pathfinder-desc">{prevItem.desc}</p>
              </div>
            )}
          </div>
        </div>
        <div className="block">
          <div className="pathfinder-next">
            {nextItem && (
              <div>
                <Link to={nextItem.path}>{nextItem.label} &rarr;</Link>
                <p className="pathfinder-desc">{nextItem.desc}</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Pathfinder;
